<div class="container">
  <app-search-bar (submitted)="onTerm($event)" (cleared)="onClearResults()"></app-search-bar>
  <app-page-list *ngIf="results.length && !notFound" [results]="results"></app-page-list>
  <div *ngIf="notFound">No results. Try another term.</div>
  <div *ngIf="loading">
    <progress class="progress is-medium is-dark" max="100">0%</progress>    
</div>
